// const api='http://localhost:4000'

const api = "https://livesite-backend-74ut.onrender.com";


export default api;
